import { useContext } from 'react';

import { PlaceholderOverrideValueContext } from './PlaceholderOverrideValueContext';

export const usePlaceholderOverrideValue = (): string | undefined => {
	const value = useContext(PlaceholderOverrideValueContext);
	if (value === null) {
		throw new Error(
			'usePlaceholderOverrideValue must be used within ChatInputPlaceholderOverrideProvider',
		);
	}
	return value;
};
